import {SvgIcon} from "@mui/material";
import {useTranslation} from "react-i18next";
import {A11yStandardType} from "../../../models/A11yStandard";
import {FC} from "react";
import FloorsSvg from "../../../assets/svg/FloorsSvg";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import HotelRoomSvg from "../../../assets/svg/HotelRoomSvg";
import AccessibilityToiletSvg from "../../../assets/svg/AccessibilityToiletSvg";
import AccessibleParkingSvg from "../../../assets/svg/AccessibleParkingSvg";
import BusinessIcon from '@mui/icons-material/Business';
import PlaygroundSvg from "../../../assets/svg/PlaygroundSvg";
import HotelIcon from "@mui/icons-material/Hotel";
import AttractionSvg from "../../../assets/svg/AttractionSvg";
import {Property} from "../../../models/Property";
import {getPropertiesOfTabGroup, MALTA_HOTELS_GROUP, MALTA_VENUES_GROUP} from "../../../constants/propertyTabs";
import {BuildingAreaKpi, getBuildingAreaKpis} from "../../../constants/kpi";
import {EMPTY_KPI_CELL, KpiCell, sortKpiCells} from "../../../components/kpi/kpiCells";
import {KpiGrid} from "../../../components/kpi/KpiGrid";

type PropsType = {
  a11yStandard: A11yStandardType;
  buildingAreaId: string;
  properties: Property[] | undefined;
  propertiesCount: number;
  shopsCount?: number;
  parkingSpaces: number;
  publicToilets: number;
  toilets: number;
}

const BuildingAreaBlockInfo: FC<PropsType> = ({
  a11yStandard,
  buildingAreaId,
  properties,
  propertiesCount,
  shopsCount,
  parkingSpaces,
  publicToilets,
  toilets,
}) => {
  const { t } = useTranslation();

  const cells: Record<BuildingAreaKpi, KpiCell> = {
    buildings: {
      title: t("building_area_buildings"),
      value: propertiesCount,
      icon: <SvgIcon fill={'#636363'}><BusinessIcon/></SvgIcon>,
    },
    floors: {
      title: t("hotel_floors"),
      value: 0,
      icon: <FloorsSvg stroke={'#636363'} height={30} width={30}/>,
    },
    shops: {
      title: t("building_area_shops"),
      value: shopsCount ? shopsCount : 0,
      icon: <SvgIcon fill={'#636363'}><ShoppingBasketIcon/></SvgIcon>,
    },
    accessibleRooms: {
      title: t("hotel_accessibleRooms"),
      value: 0,
      icon: <HotelRoomSvg fill={'#636363'}/>,
    },
    allergyRooms: {
      title: t("hotel_allergyRooms"),
      value: 0,
    },
    parkingSpaces: {
      title: t("building_area_parking_spaces"),
      value: parkingSpaces,
      icon: <AccessibleParkingSvg fill={'#636363'}/>,
    },
    toilets: {
      title: t('amount_of_accessible_toilets'),
      value: toilets,
      icon: <AccessibilityToiletSvg fill={'#636363'}/>,
    },
    publicToilets: {
      title: t('amount_of_accessible_toilets'),
      value: publicToilets,
      icon: <AccessibilityToiletSvg fill={'#636363'}/>,
    },
    playgrounds: {
      title: t('inventoried_playgrounds'),
      value: propertiesCount,
      icon: <PlaygroundSvg fill={'#636363'}/>,
    },
    hotels: {
      title: t('hotels'),
      value: properties ? getPropertiesOfTabGroup(properties, MALTA_HOTELS_GROUP).length : undefined,
      icon: <SvgIcon fill={'#636363'}><HotelIcon/></SvgIcon>,
    },
    venues: {
      title: t('venues'),
      value: properties ? getPropertiesOfTabGroup(properties, MALTA_VENUES_GROUP).length : undefined,
      icon: <AttractionSvg fill={'#636363'}/>,
    },
    empty: EMPTY_KPI_CELL,
  }

  const shownCells = sortKpiCells(getBuildingAreaKpis(a11yStandard.key, buildingAreaId).map((kpi) => cells[kpi]))

  return <KpiGrid cells={shownCells}/>
}

export default BuildingAreaBlockInfo
